import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import Icon from '../components/views/icon';

const getUUID = () => uuidv4();

const getSplitSlice = (str, splitBy, index) => str.split(`${splitBy}`)[index];

const isEmpty = (val) => val.trim().length === 0;

const formatDate = (date) => new Date(date).toLocaleDateString('en-GB', {
  day: 'numeric', month: 'short', year: 'numeric',
}).replace(/ /g, '-');

function findAncestorMatch(node, targetNode) {
  let currentNode = node;
  while (currentNode !== null) {
    if (currentNode === targetNode) {
      return currentNode;
    }
    currentNode = currentNode.parentNode;
  }
  return null;
}

// eslint-disable-next-line
const getRenderIcon = (icon) => icon ? (({ size, color }) => <Icon icon={icon} size={size} color={color} />) : null;
// TODO: export this function to a separate file later on,
// since it's not appropriate for JSX to be dealt with util files.

export {
  getUUID,
  getSplitSlice,
  isEmpty,
  formatDate,
  getRenderIcon,
  findAncestorMatch,
};
